import { Component, ElementRef, Input } from '@angular/core';
import { Globals } from '../../providers/globals';
import { NavController, Platform  } from 'ionic-angular';

import { BusinessMessageDetailImagePage } from '../../pages/business-message-detail-image/business-message-detail-image';
import { LaunchNavigator, LaunchNavigatorOptions } from '@ionic-native/launch-navigator';

declare var google: any;

@Component({
  selector: 'consumer-message-block',
  templateUrl: 'consumer-message-block.html'
})
export class ConsumerMessageBlockComponent {
	@Input('message') message;
	hasCoordinates: boolean = false;
	map: any;

	constructor(
		public elRef: ElementRef,
		public globals: Globals, public navCtrl: NavController,
		public platform: Platform,
		private launchNavigator: LaunchNavigator
	) {

	}

	ngAfterViewInit(){
		if(this.message.GeoLat){
			this.loadGoogleMap({
				latitude: this.message.GeoLat, 
				longitude: this.message.GeoLong
			})
		}		
	}	

	loadGoogleMap(coords){
		setTimeout(()=>{
			let el = this.elRef.nativeElement.getElementsByClassName('map');

	        this.map = new google.maps.Map(el[0], {
	          	center: {lat: coords.latitude, lng: coords.longitude},
	          	zoomControl: false,    
	          	zoom: 14,
				disableDefaultUI: true,	          	
	        });	

			var latLong = {lat: coords.latitude, lng: coords.longitude};			
			
	        var marker = new google.maps.Marker({
				position: latLong,
				map: this.map,
				title: "Your location",          
	        }); 				
		}, 1000);
	}		

	openMap(){
		this.platform.ready().then((readySource) => {
			if(readySource=="dom") return

			var coords = this.message.GeoLat + ',' + this.message.GeoLong;

			let options: LaunchNavigatorOptions = {
			  app: this.launchNavigator.APP.GOOGLE_MAPS
			};

			this.launchNavigator.isAppAvailable(this.launchNavigator.APP.GOOGLE_MAPS)
			.then((isAvailable)=>{
			    var app;

			    if(isAvailable){
			        app = this.launchNavigator.APP.GOOGLE_MAPS;
			    }else{
			        app = this.launchNavigator.APP.USER_SELECT;
			    }

				this.launchNavigator.navigate(coords, options)
				.then(
					success => console.log('Launched navigator'),
					error => console.log('Error launching navigator', error)
				);
			})
			.catch(function(e){
				console.log("Error")
				console.log(e)
			});
		});
	}	

	viewImage(imageSrc) {
		this.navCtrl.push(BusinessMessageDetailImagePage, {
		  imageSrc: imageSrc
		})
	}	
}



// WEBPACK FOOTER //
// ./src/components/consumer-message-block/consumer-message-block.ts